import {Component, Input, EventEmitter, Output, ChangeDetectorRef} from '@angular/core';
import {tap, take, concatMap, takeUntil, filter} from "rxjs/operators";
import {ComponentTypeService} from "../../../services/models/component-type.service";
import {ComponentType} from "../../../_models/component-type";
import {ComponentNameFormulaBuilderService} from "../../../services/component-name-formula-builder.service";
import {IDMap, KeyMap} from "../../../_typing/generic-types";
import {ConstantProperty} from "../../../_models/constant-property";
import {BaseComponent} from "../../../shared/base.component";
import {of} from "rxjs";
import {
    FormulaPart,
    FormulaPartType,
    NameFormula,
    SelectedNameFormula
} from "../../../_typing/config/component-name-formula-config";
import {COMMON_FORM_IMPORTS} from "../../../shared/import-groups/Common";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'component-name-formula-selector',
    templateUrl: './component-name-formula-selector.component.html',
    styleUrls: ['./component-name-formula-selector.component.less'],
    imports: [
        COMMON_FORM_IMPORTS,
        CommonModule
    ],
})
export class ComponentNameFormulaSelectorComponent extends BaseComponent {
    private _componentType: Partial<ComponentType>;
    @Input() set componentType(componentType: Partial<ComponentType>) {
        if (componentType?.id !== this._componentType?.id) {
            this._componentType = componentType;
            this.loadForm();
        }
        this._componentType = componentType;
    };

    get componentType(): Partial<ComponentType> {
        return this._componentType;
    }

    @Input() label: string = 'Formula options';
    @Input() filterTypes: FormulaPartType[] = [];
    @Input() useNameFormula: boolean;
    @Output() useNameFormulaChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() selectedNameFormula: SelectedNameFormula;
    @Output() selectedNameFormulaChange = new EventEmitter<SelectedNameFormula>();

    nameFormulaOptions: KeyMap<NameFormula> = {};
    cpDict: IDMap<ConstantProperty> = {};
    formula: NameFormula;
    formulaKey: number;
    cpsReady = false;

    constructor(private componentTypeService: ComponentTypeService,
                private formulaBuilder: ComponentNameFormulaBuilderService,
                private cdr: ChangeDetectorRef) {
        super();

    }

    ngOnInit() {
        this.compareFormula = this.compareFormula.bind(this);
        this.formula = this.selectedNameFormula?.formula;
        this.formulaKey = this.selectedNameFormula?.key;
    }

    loadForm() {
        this.componentTypeService.getComponentType(this.componentType.id)
            .pipe(concatMap(result => {
                this.componentType = result.data;
                this.nameFormulaOptions = this.componentType.attributes.json?.name_formulas || {};

                if (this.filterTypes?.length) {
                    this.nameFormulaOptions = this.filterFixedOptions();
                }

                return this.formulaBuilder.getProperties(this.nameFormulaOptions)
                    .pipe(tap(result => {
                        result?.data.forEach(cp => this.cpDict[cp.id] = cp);
                        this.cpDict = Object.assign({}, this.cpDict);
                        this.cdr.markForCheck();
                    }))
            }), take(1), takeUntil(this.onDestroy))
            .subscribe(()=> this.cpsReady = true);
    }

    filterFixedOptions(): KeyMap<NameFormula> {
        let filteredOptions = {};
        /*Formulas can not have any of the types specified in filterTypes Input*/
        Object.keys(this.nameFormulaOptions).forEach(option => {
            if (!this.nameFormulaOptions[option].some(opt => this.filterTypes.includes(opt.type))) {
                filteredOptions[option] = this.nameFormulaOptions[option];
            }
        })
        return filteredOptions;
    }

    formulaSelected(event): void {
        this.selectedNameFormula = {key: event.value, formula: this.nameFormulaOptions[event.value] || null};
        this.selectedNameFormulaChange.emit(this.selectedNameFormula);
    }

    getNameString(formula: FormulaPart[]): string {
        return this.formulaBuilder.getNameString(formula, this.cpDict);
    }

    compareFormula(option, selected) {
        return option == selected ||
            this.formulaBuilder.getFormulaString(this.nameFormulaOptions[option]) === this.formulaBuilder.getFormulaString(this.selectedNameFormula?.formula);
    }
}
